import React from "react"
import styled from "styled-components"

const Checkbox = ({ handleChecked, value }) => (
    <input type="checkbox" checked={value} onChange={handleChecked} />
)
export const CalendarBooleanField = ({
    label,
    value,
    handleChecked,
    detail,
    configId,
}) => {
    return (
        <Style>
            <div className="fragment">
                <Checkbox
                    value={value}
                    handleChecked={() => handleChecked(!value, configId)}
                />
                <h5 className="checkbox-label">{label}</h5>
            </div>
            {detail && detail}
        </Style>
    )
}
const Style = styled.div`
    padding: 10px 0px;
    .fragment {
        display: flex;
        align-items: center;
    }
    h5 {
        margin: 0px;
    }
    input[type="checkbox"] {
        margin: 0 10px 0 0;
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/calendar_boolean_field.jsx